import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FirebaseTSAuth } from 'firebasets/firebasetsAuth/firebaseTSAuth';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-authenticator',
  templateUrl: './authenticator.component.html',
  styleUrls: ['./authenticator.component.css']
})
export class AuthenticatorComponent implements OnInit {
  state = AuthenticatorCompState.LOGIN;
  firebasetsAuth: FirebaseTSAuth;
  constructor(private bottomSheetRef: MatBottomSheetRef) { 
    this.firebasetsAuth = new FirebaseTSAuth();
  }

   isPlaying: boolean = true;
  
  
    @ViewChild('audioPlayer', { static: false }) audioPlayer!: ElementRef;

  ngOnInit(): void {
    this.changeAudioSrc(); // Joue l'audio au chargement
  }

  toggleAudio() {
    const audio: HTMLAudioElement = this.audioPlayer.nativeElement;
    if (audio.paused) {
      audio.play();
      this.isPlaying = true;
    } else {
      audio.pause();
      this.isPlaying = false;
    }
  }

  onAudioPlay() {
    this.isPlaying = true;  // Mettre à jour l'état lorsque l'audio commence à jouer
  }

  onAudioPause() {
    this.isPlaying = false;  // Mettre à jour l'état lorsque l'audio est mis en pause
  }

  changeAudioSrc() {
    if (!this.audioPlayer) return;

    const audio: HTMLAudioElement = this.audioPlayer.nativeElement;
    
    switch (this.state) {
      case AuthenticatorCompState.LOGIN:
        audio.src = "../../../assets/audio/02_Bambara_Connecter_Creer_Oublie.m4a";
        break;
      case AuthenticatorCompState.REGISTER:
        audio.src = "../../../assets/audio/03_Bambara_Creer_compte.m4a";
        break;
      case AuthenticatorCompState.FORGOT_PASSWORD:
        audio.src = "../../../assets/audio/audio_mot_de_passe_oublie.m4a";
        break;
      
    }

    audio.load(); // Recharge l'audio
    audio.play(); // Joue automatiquement après le changement
    this.isPlaying = true;
  }

  onResetClick(resetEmail: HTMLInputElement){
    let email = resetEmail.value;
    if(this.isNotEmpty(email)) {
      this.firebasetsAuth.sendPasswordResetEmail(
        {
          email: email,
          onComplete: (err) => {
            this.bottomSheetRef.dismiss();
            let email = resetEmail.value;
          }
        }
      );
    }
  }


  onLogin(
    loginEmail: HTMLInputElement,
    loginPassword: HTMLInputElement
  ){
    let email = loginEmail.value;
    let password = loginPassword.value;

    if(this.isNotEmpty(email) && this.isNotEmpty(password)) {
      this.firebasetsAuth.signInWith(
        {
          email: email,
          password: password,
          onComplete: (uc) => {
            this.bottomSheetRef.dismiss();
          },
          onFail: (err) => {
            alert("On ne trouve pas l'utilisateur avec cet identifiant. Il a peut-être été supprimé ou les informations sont érronées.");
          }
        }
      );
    }

  }

  onRegisterClick(
    registerEmail: HTMLInputElement,
    registerPassword: HTMLInputElement,
    registerConfirmPassword: HTMLInputElement
  ){
    let email = registerEmail.value;
    let password = registerPassword.value;
    let confirmPassword = registerConfirmPassword.value;

    if(
      this.isNotEmpty(email) &&
      this.isNotEmpty(password) && 
      this.isNotEmpty(confirmPassword) &&
      this.isAMatch(password, confirmPassword)
    ){
      this.firebasetsAuth.createAccountWith(
        {
          email: email,
          password: password,
          onComplete: (uc) => {
            this.bottomSheetRef.dismiss();
          },

          onFail: (err) => {
            alert("Echec lors de la création de votre compe. Verifiez si vos informations sont correctes!");
          }
          
        }
      );
    }

  }

  isNotEmpty(text: string){
    return text != null && text.length > 0;
  }

  isAMatch(text: string, comparedWith: string){
    return text == comparedWith;
  }

  onForgotPasswordClick(){
    this.state = AuthenticatorCompState.FORGOT_PASSWORD;
    
  }

  onCreateAccountClick(){
    this.state = AuthenticatorCompState.REGISTER;
    this.changeAudioSrc();
  }

  onLoginClick(){
    this.state = AuthenticatorCompState.LOGIN;
    this.changeAudioSrc();
  }

  isLoginState(){
    return this.state == AuthenticatorCompState.LOGIN;
  }

  isRegisterState(){
    return this.state == AuthenticatorCompState.REGISTER;
  }

  isForgotPasswordState(){
    return this.state == AuthenticatorCompState.FORGOT_PASSWORD;
  }

  getStateText(){
    switch(this.state){
      case AuthenticatorCompState.LOGIN:
        return "Se connecter";
      case AuthenticatorCompState.REGISTER:
        return "S'inscrire";
      case AuthenticatorCompState.FORGOT_PASSWORD:
        return "Mot de passe oublié?";
    }
  }

}

export enum AuthenticatorCompState {
  LOGIN,
  REGISTER,
  FORGOT_PASSWORD
}
